// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wlue","content":"styles_content__1vakb"};